export const container = "max-w-[600px] mx-auto px-4 bg-[#ffffff]";

export const disabled = "pointer-events-none opacity-10";
